import { Component } from "react"
import PropTypes from "prop-types"
import DataLibrarySettings from "./components/settings"
import Subscriptions from "./containers/subscriptions"
import Browse from "./containers/browse"
import { getCurrentRoute } from "./helpers"
import { ROLE } from "helpers/shapes"

import "./style.scss"

export default class DataCloud extends Component {
  static propTypes = {
    datasets: PropTypes.array.isRequired,
    accountDatasets: PropTypes.array.isRequired,
    urlGetter: PropTypes.func.isRequired,
    defaultTab: PropTypes.string,
    searchQuery: PropTypes.func.isRequired,
    searchFilter: PropTypes.func.isRequired,
    contactUs: PropTypes.func.isRequired,
    notFound: PropTypes.func.isRequired,
    reactivate: PropTypes.func.isRequired,
    role: ROLE.isRequired,
    account: PropTypes.string.isRequired,
    entitlementsEnabled: PropTypes.bool.isRequired,
    navigate: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      scope: "subscriptions",
      currentTab: getCurrentRoute(),
    }
  }

  componentDidUpdate() {
    const { currentTab } = this.state
    const tab = getCurrentRoute()
    // this is to handle someone changing the url via the home side menu
    if (tab !== currentTab) {
      this.setState({ currentTab: tab })
    }
  }

  changeScope = (e) => {
    this.setState({ scope: e.target.value })
  }

  changeTab = (e, newValue) => {
    const { urlGetter, navigate } = this.props
    this.setState({ currentTab: newValue })
    navigate(urlGetter(newValue))
  }

  render() {
    const { scope, currentTab } = this.state
    const { accountDatasets, datasets, searchQuery, searchFilter, contactUs, reactivate, notFound, role, account, entitlementsEnabled } = this.props
    return <div className="module_data-cloud">
      <DataLibrarySettings scope={scope} currentTab={currentTab} changeScope={this.changeScope} changeTab={this.changeTab} />

      {scope === "subscriptions" && currentTab === "active"
        && <Subscriptions datasets={accountDatasets} role={role} account={account} entitlementsEnabled={entitlementsEnabled} />}
      {scope === "subscriptions" && currentTab === "browse"
        && <Browse
          datasets={datasets}
          tracking={{
            searchQuery,
            searchFilter,
            contactUs,
            reactivate,
            notFound,
          }}
        />}
    </div>
  }
}
